import ActionCell from '@nile/banyan/src/Pages/ServiceCatalog/ActionCell';
import LinkCell from '@nile/banyan/src/Pages/ServiceCatalog/LinkCell';
import {
  InlineFilter,
  Loader,
  NoDataCard,
  Pagination,
  Icon
} from '@nile/components';
import { Button, TextStyle } from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import envConfig from '@nile/home/src/Config/env';
import { TextCell } from '@nile/mangifera/src/Components/Ticket';
import { Copy, SortDown, SortUp } from '@styled-icons/boxicons-regular';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FormattedMessage } from 'react-intl';
import {
  useFilters,
  useFlexLayout,
  useGlobalFilter,
  usePagination,
  useResizeColumns,
  useRowSelect,
  useTable
} from 'react-table';
import styled from 'styled-components';
import { ReactTableDragAndDrop } from './DnDReactTable';
import { arrayMove } from '@dnd-kit/sortable';

const Styles = styled.div`
  .table-content {
    height: calc(100% - 50px); //reduce header height
  }
  .columHeader {
    min-height: 50px;
    height: auto !important;
    padding: ${(props) => (props.cardTable ? '0px 40px' : '')};
    background: ${(props) => (props.dark ? '#333' : 'var(--sops-table-bg)')};
    ${(props) => (props.hideBorderTop ? 'border-top: none;' : '')};
  }
  .table > thead:first-child > tr:first-child {
    display: none !important;
  }
  .unfreezeContent {
    align-items: flex-start;
    position: relative;
  }
  /* Hide scrollbar for Chrome, Safari and Opera */
  .unfreezeHeader::-webkit-scrollbar {
    display: none;
  }

  .unfreezeHeader {
    scrollbar-width: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  .unfreezeHeader {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }

  .columnHeader {
    width: 100%;
  }

  .deleteItem {
    visibility: hidden;
  }

  .action-button {
    visibility: hidden;
  }

  .action-button-bg {
    visibility: visible;
  }

  .p-0 {
    padding: 0px !important;
  }

  .px-10 {
    padding: 0 10px !important;
  }

  .colHeader {
    text-transform: uppercase;
    font-size: 12px;
    color: ${(props) =>
      props.dark ? 'rgba(255,255,255,1)' : 'rgba(0,0,0,0.6)'};
    background: ${(props) => (props.dark ? '#333' : '#fffff')};
    border-right: ${(props) =>
      props.dark
        ? '1px solid rgba(255,255,255,0.6)'
        : '1px solid rgba(0,0,0,0.1)'};
    height: 50%;
    margin: 4px 0;
    margin-top: 15px;
  }

  .tbody {
    .tr {
      min-height: 50px !important;
      border-bottom: ${(props) => (props.dark ? '1px solid #ececec' : 'none')};
    }
    .tr:hover {
      .td {
        background: #f5f5fc;
      }
      .copy {
        visibility: visible;
      }
      .editable-cell {
        background: #fff;
        border: 1px solid #d4d4d4;
      }
      .edit-actions {
        visibility: visible;
      }
      .deleteItem {
        visibility: visible;
      }
      .action-button {
        visibility: visible;
      }
      .action-button-bg {
        visibility: hidden;
      }
      .multi-action {
        display: flex !important;
      }

      .take-action {
        display: none !important;
      }
    }
    .editable-cell {
      border-radius: 4px;
      height: 80%;
      font-weight: normal !important;
      border: 1px solid transparent;
    }
    .td {
      background: var(--sops-table-bg);
      align-items: ${(props) =>
        props.alignStart ? 'flex-start' : 'center'} !important;
      border-bottom: 1px solid transparent;
      padding: ${(props) =>
        props.alignStart ? '15px 5px 5px 5px' : '8px 5px'};
    }
  }

  .resizer {
    display: inline-block;
    //background: #ececec;
    width: 5px;
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
    transform: translateX(50%);
    z-index: 1;
    ${'' /* prevents from scrolling while dragging on touch devices */}
    touch-action:none;

    &.isResizing {
      background: red;
    }
  }
  .unfreezeContent {
    align-items: flex-start;
    position: relative;
  }
  .no-data-found-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 100px;
  }
  .empty-state-msg {
    font-size: 14px;
    margin-right: 20px;
  }
  height: ${(props) => (props.fullHeight ? '100%' : 'auto')};
  .table {
    height: calc(100% - 60px);
    padding-bottom: 10px;
  }
`;

const SortUpIcon = styled(SortUp)`
  width: 20px;
  height: 20px;
`;

const SortDownIcon = styled(SortDown)`
  width: 20px;
  height: 20px;
`;

const Header = styled.div`
  font-weight: ${(props) => (props.isSorted ? '500' : 'normal')};
  cursor: ${(props) => (props.canSort ? 'pointer' : 'auto')};
  display: flex;
  align-items: center;
  margin-right: 8px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const TableHeaderWrapper = styled.th`
  padding: 0;
  padding-left: ${(props) => (props.cardTable ? '' : '4px')};
  min-height: 100%;
  .filter-icon {
    margin-left: auto;
    margin-right: 2px;
    visibility: hidden;
    cursor: pointer;
  }
  .icon {
    visibility: hidden;
    cursor: pointer;
  }
  .action-button {
    visibility: hidden;
  }
  .action-button-bg {
    visibility: visible;
  }
  &:hover {
    .filter-icon {
      visibility: visible !important;
    }
    .action-button {
      visibility: visible;
    }
    .action-button-bg {
      visibility: hidden;
    }
    .icon {
      visibility: visible;
    }
  }
`;

function DragHandleCell(props) {
  return (
    <ReactTableDragAndDrop.DragHandleController {...props}>
      {props.cell?.column?.editMode ? (
        <div>
          <SVGIcon name="Reorder" />
        </div>
      ) : (
        <></>
      )}
    </ReactTableDragAndDrop.DragHandleController>
  );
}

const IndeterminateCheckbox = React.forwardRef(
  ({ indeterminate, row, ...rest }, ref) => {
    const defaultRef = React.useRef();
    const resolvedRef = ref || defaultRef;

    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);
    const isEditEnabled = row?.original?.isDefault
      ? row?.original?.isDefault
      : row?.original?.followerPermission
      ? JSON.parse(row?.original?.followerPermission).Tickets.indexOf(
          'Edit'
        ) === -1
      : false;
    return (
      <>
        <input
          type="checkbox"
          ref={resolvedRef}
          {...rest}
          disabled={isEditEnabled}
        />
      </>
    );
  }
);

const cellProps = (props, { cell }) => getStyles(props, cell.column.align);

const getStyles = (props, align = 'left') => [
  props,
  {
    style: {
      justifyContent: align === 'right' ? 'flex-end' : 'flex-start',
      alignItems: 'flex-start',
      display: 'flex'
    }
  }
];

function FilterCell(props) {
  const { column, context, getAttributeName } = props;
  return (
    <InlineFilter
      allConditions={context.viewConditions}
      meta={{
        ...column.helpers,
        field: column.field,
        entity: column?.helpers?.entity || 'Ticket',
        getAttributeName
      }}
    />
  );
}

const defaultColumn = {
  minWidth: 30,
  maxWidth: 500,
  width: 150,
  Link: LinkCell,
  Text: TextCell,
  Action: ActionCell,
  Drag: DragHandleCell
};

function TableHeaders(props) {
  const {
    column,
    context,
    refreshTable,
    rowCount,
    pageNumber,
    listInfo,
    showFilters,
    toggleFilters,
    bulkSelectValues,
    cardTable,
    noIndicators,
    disableSelectAll
  } = props;
  const getAttributeName = () => {
    switch (column?.field?.name) {
      case 'prioritizedId':
        return 'displayId';
      case 'client':
        return 'client.name';
      case 'site':
        return 'site.name';
      case 'requester':
        return 'requester.name';
      case 'technician':
        return 'technician.name';
      case 'techGroup':
        return 'techGroup.name';
      case 'firstResponseTimer':
        return 'firstResponseDueTime';
      case 'resolutionTimer':
        return 'resolutionDueTime';
      case 'sla':
        return 'sla.name';
      default:
        return column?.field?.name;
    }
  };
  const sortCurrentColumn = () => {
    if (column.disableSortBy) return;
    const attributeName = props.getAttributeName
      ? props.getAttributeName(column?.field || {})
      : getAttributeName();
    refreshTable(context.personalization, {
      pageSize: rowCount,
      page: 1,
      condition: context.viewConditions || null,
      sort:
        listInfo?.sort?.[0]?.order === 'DESC'
          ? listInfo?.sort?.[0]?.attribute === attributeName
            ? null
            : [
                {
                  attribute: attributeName,
                  order: 'ASC'
                }
              ]
          : [
              {
                attribute: attributeName,
                order:
                  listInfo?.sort?.[0]?.attribute === attributeName
                    ? listInfo?.sort?.[0]?.order === 'ASC'
                      ? 'DESC'
                      : 'ASC'
                    : 'ASC'
              }
            ]
    });
  };
  const attributeName = props.getAttributeName
    ? props.getAttributeName(column?.field || {})
    : getAttributeName();
  const isSorted =
    listInfo?.sort && listInfo?.sort?.[0].attribute === attributeName;
  const isFiltered =
    context?.viewConditions?.operands?.findIndex((el) =>
      column?.field?.dataType === 'entity'
        ? el.attribute === `${column?.field?.name}.name`
        : el.attribute === column?.field?.name
    ) > -1;
  const isSortedDesc = listInfo?.sort?.[0].order === 'DESC';
  return (
    <TableHeaderWrapper
      cardTable={cardTable}
      className="inblock"
      {...(column.id === 'selection'
        ? column.getHeaderProps()
        : column.getHeaderProps())}
    >
      <div
        className={`fx ${column.id !== 'selection' ? 'th colHeader' : 'fx'}`}
      >
        {column.id === 'selection' ? (
          <div className="mt-15">{column.render('Header')}</div>
        ) : (
          <Header
            isSorted={isSorted}
            canSort={!column.disableSortBy}
            alignRight={column.alignRight}
            onClick={sortCurrentColumn.bind(this, column)}
            className={`${column.alignRight ? 'full-width jend' : ''}`}
          >
            {column?.canSelectAllHeader ? (
              <div className="flex actr">
                <input
                  type="checkbox"
                  checked={
                    bulkSelectValues?.[pageNumber]?.[column?.field?.name]
                  }
                  onChange={() => {
                    column.actions.onBulkSelect(
                      !bulkSelectValues?.[pageNumber]?.[column?.field?.name]
                    );
                  }}
                />
                <div className="ml8">
                  <TextStyle>
                    <FormattedMessage id={column?.field?.label || ''} />
                  </TextStyle>
                </div>
              </div>
            ) : (
              <TextStyle>{column?.field?.label || ''}</TextStyle>
            )}
          </Header>
        )}
        {column.canResize && (
          <div
            {...column.getResizerProps()}
            className={`resizer ${column.isResizing ? 'isResizing' : ''}`}
          />
        )}
        {column.id !== 'selection' && isSorted && !noIndicators ? (
          <div
            active={column.isSorted}
            onClick={sortCurrentColumn.bind(this, column)}
          >
            {isSortedDesc ? <SortDownIcon /> : <SortUpIcon />}
          </div>
        ) : (
          column.id !== 'selection' &&
          !column.disableSortBy &&
          !noIndicators && (
            <div
              className="icon"
              onClick={sortCurrentColumn.bind(this, column)}
            >
              <SortUpIcon />
            </div>
          )
        )}
        {(column.canFilter || isFiltered) && !noIndicators && (
          <FilterIcon className="filter-icon" active={isFiltered}>
            <div onClick={toggleFilters}>
              <SVGIcon name="Filter" />
            </div>
          </FilterIcon>
        )}
      </div>
      {column.id !== 'selection' && column.canFilter && showFilters && (
        <div>
          <FilterCell
            column={column}
            context={context}
            getAttributeName={props.getAttributeName}
          />
        </div>
      )}
    </TableHeaderWrapper>
  );
}

/**
 * Common Table component for the application.
 */
const TableView = ({
  columns,
  data,
  pagination,
  setData,
  updateMyData,
  skipPageReset,
  refreshTable,
  rowCount,
  setSelectedRows,
  defaultColumnCells = {},
  pages,
  listInfo,
  activePage,
  noBulkSelect,
  disableSelectAll,
  recordCount,
  isLoading,
  context,
  getAttributeName,
  noDataFound,
  noDataContent,
  isClientPagination,
  currentPage,
  setCurrentPage,
  bulkSelectValues = {},
  errors = null,
  actions,
  emptyState,
  fullHeight,
  cardTable,
  dark,
  skipNoData,
  hideBorderTop,
  alignStart,
  checkRowHighlight,
  checkDisabledRow,
  noIndicators,
  maintainPageOnRecordsChange,
  onDragEnd,
  getRowId,
  disableDragAndDrop = false
}) => {
  const {
    getTableProps,
    headerGroups,
    prepareRow,
    page,
    gotoPage,
    setPageSize,
    canPreviousPage,
    previousPage,
    nextPage,
    canNextPage,
    pageCount,
    pageOptions,
    selectedFlatRows,
    toggleAllRowsSelected,
    state: { pageIndex, pageSize, selectedRowIds, sortBy }
  } = useTable(
    {
      columns,
      data,
      defaultColumn: { ...defaultColumn, ...defaultColumnCells },
      autoResetPage: !skipPageReset,
      updateMyData,
      refreshTable,
      actions,
      manualFilters: true
      // disableSortBy: true
    },
    useResizeColumns,
    useGlobalFilter,
    useFilters,
    usePagination,
    useRowSelect,
    useFlexLayout,
    (hooks) => {
      if (!noBulkSelect) {
        hooks.allColumns.push((columns) => [
          {
            id: 'selection',
            disableResizing: true,
            minWidth: 35,
            width: 35,
            maxWidth: 35,
            Header: ({ getToggleAllRowsSelectedProps }) => {
              return !disableSelectAll ? (
                <div>
                  <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
                </div>
              ) : (
                <></>
              );
            },
            Cell: ({ row }) => (
              <div>
                <IndeterminateCheckbox
                  {...row.getToggleRowSelectedProps()}
                  row={row}
                />
              </div>
            )
          },
          ...columns
        ]);
        hooks.useInstanceBeforeDimensions.push(({ headerGroups }) => {
          // fix the parent group of the selection button to not be resizable
          const selectionGroupHeader = headerGroups[0].headers[0];
          selectionGroupHeader.canResize = false;
        });
      }
    }
  );
  const freezedColumns = React.useRef(0);
  const normalcolumns = React.useRef(1);
  const normalColHeaders = React.useRef(2);
  const [showFilters, setShowFilters] = useState(!!context.viewConditions);
  const [tableHeight, setTableHeight] = useState(null);
  const [copied, setCopyState] = useState(false);
  const toggleFilters = useCallback(() => {
    setShowFilters(!showFilters);
  });
  const scollTableBody = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (
      !(
        e.target === freezedColumns.current ||
        e.target === normalColHeaders.current ||
        e.target === normalcolumns?.current
      )
    ) {
      return;
    }
    const scrollElement =
      e.target === freezedColumns.current ? normalcolumns : freezedColumns;
    if (scrollElement.current)
      scrollElement.current.scrollTop = e.target.scrollTop;
    if (normalColHeaders.current)
      normalColHeaders.current.scrollLeft = e.target.scrollLeft;
    if (e.target === normalColHeaders.current)
      normalcolumns.current.scrollLeft = e.target.scrollLeft;
  };

  useEffect(() => {
    const rows = [];
    for (let i = 0; i < selectedFlatRows.length; i++) {
      rows.push(selectedFlatRows[i].original);
    }
    context.setRecords && context.setRecords(rows);
  }, [selectedRowIds]);

  useEffect(() => {
    setPageSize(rowCount);
  }, [rowCount]);

  useEffect(() => {
    setPageSize(rowCount);
  }, []);

  useEffect(() => {
    if (context?.records?.length !== selectedFlatRows.length) {
      if (maintainPageOnRecordsChange) {
        refreshTable(context.personalization, {
          pageSize: rowCount,
          page: listInfo.page || 0,
          condition: context.viewConditions || null,
          sort: listInfo.sort || null
        });
      } else {
        refreshTable(context.personalization);
      }

      if (!context?.records?.length) toggleAllRowsSelected(false);
    }
  }, [context.records]);

  useEffect(() => {
    if (
      normalColHeaders?.current?.offsetHeight &&
      tableHeight !== normalColHeaders?.current?.offsetHeight
    ) {
      setTableHeight(normalColHeaders.current.offsetHeight);
    }
  }, [normalColHeaders?.current?.offsetHeight]);

  useEffect(() => {
    // Changes in Webroot when switching views when current page is not the starting page
    if (isClientPagination && currentPage) {
      gotoPage(currentPage - 1);
    }
  }, [currentPage]);

  const navigatePages = useCallback((pageNumber) => {
    if (isClientPagination) {
      gotoPage(pageNumber - 1);
      setCurrentPage(pageNumber);
    } else {
      refreshTable(context.personalization, {
        pageSize: rowCount,
        page: pageNumber || 0,
        condition: context.viewConditions || null,
        sort: listInfo.sort || null
      });
    }
  });

  const checkSelectedRow = (row) => {
    const isSelected = selectedFlatRows.find((el) => el.id === row.id);
    if (checkRowHighlight) {
      return checkRowHighlight(row) || !!isSelected;
    }
    return !!isSelected;
  };

  const isRowDisabled = (row) => {
    if (checkDisabledRow) {
      return checkDisabledRow(row);
    }
    return false;
  };

  const itemIds = useMemo(
    () => data.map(getRowId ? getRowId : (item) => item.itemId),
    [data]
  );

  // Render the UI for your table
  return (
    <Styles
      cardTable={cardTable}
      fullHeight={fullHeight}
      dark={dark}
      hideBorderTop={hideBorderTop}
      alignStart={alignStart}
    >
      <table {...getTableProps()} className="table block full-width">
        <thead className="block">
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()} className="tr">
              <div className="fx columHeader">
                <div
                  className="unFreezeContent fx fh actr unfreezeHeader"
                  onScroll={scollTableBody}
                  ref={(node) => {
                    normalColHeaders.current = node;
                  }}
                >
                  {headerGroup.headers.map((column, i) => {
                    return (
                      <TableHeaders
                        cardTable={cardTable}
                        showFilters={showFilters}
                        toggleFilters={toggleFilters}
                        pageNumber={pageIndex}
                        refreshTable={refreshTable}
                        column={column}
                        rowCount={rowCount}
                        context={context}
                        listInfo={listInfo}
                        getAttributeName={getAttributeName}
                        bulkSelectValues={bulkSelectValues}
                        noIndicators={noIndicators}
                        disableSelectAll={disableSelectAll}
                      />
                    );
                  })}
                </div>
              </div>
            </tr>
          ))}
        </thead>
        <tbody className="table-content block">
          <TableBodyWrapper
            cardTable={cardTable}
            className="tbody unFreezeContent"
            onScroll={scollTableBody}
            maxHeight={tableHeight}
            ref={normalcolumns}
          >
            <ReactTableDragAndDrop
              onDragEnd={(event) => {
                if (!onDragEnd) return;
                const { active, over } = event;
                if (active && over && active.id !== over.id) {
                  const oldIndex = itemIds.indexOf(active.id);
                  const newIndex = itemIds.indexOf(over.id);
                  onDragEnd(arrayMove(data, oldIndex, newIndex), event);
                }
              }}
              getRowId={getRowId ? getRowId : (original) => original.itemId}
            >
              <ReactTableDragAndDrop.SortableContextBody listOfIds={itemIds}>
                {page.map((row) => {
                  prepareRow(row);
                  return (
                    <ReactTableDragAndDrop.DraggableRow
                      row={row}
                      disableDragAndDrop={disableDragAndDrop}
                    >
                      {({ ref, style }) => (
                        <Tr
                          {...row.getRowProps()}
                          className="tr"
                          isSelected={checkSelectedRow(row)}
                          isLoading={isLoading}
                          isDisabled={isRowDisabled(row)}
                          style={{
                            ...row.getRowProps().style,
                            ...style
                          }}
                          ref={ref}
                        >
                          {row.cells.map((cell, j) => {
                            return (
                              <td
                                {...cell.getCellProps(cellProps)}
                                className={`td ${
                                  cell?.column?.copyToClipboard
                                    ? 'sops-pos-relative'
                                    : ''
                                }`}
                              >
                                {cell.column.hasOwnProperty('type')
                                  ? cell.render(cell.column.type, { errors })
                                  : cell.render('Cell')}
                                {cell?.column?.copyToClipboard && cell.value && (
                                  <div className="copy action-visibility copy-clip-board-wraper">
                                    <CopyToClipboard
                                      text={cell.value}
                                      onCopy={() => {
                                        setCopyState(!copied);
                                      }}
                                    >
                                      <Button
                                        plain
                                        icon={
                                          <SVGIcon
                                            name="CopyClipboard"
                                            size="sm"
                                          />
                                        }
                                      />
                                    </CopyToClipboard>
                                  </div>
                                )}
                              </td>
                            );
                          })}
                        </Tr>
                      )}
                    </ReactTableDragAndDrop.DraggableRow>
                  );
                })}
              </ReactTableDragAndDrop.SortableContextBody>
            </ReactTableDragAndDrop>
            {!skipNoData &&
              !isLoading &&
              !data?.length &&
              (noDataContent || (
                <div className="flex full-height center jcenter mt25">
                  <NoDataCard
                    imageURL={`url(${emptyState?.nodataImage ||
                      `${envConfig.imageRoot}svg/not-found.svg`})`}
                    text={
                      emptyState?.heading || (
                        <FormattedMessage id="app.selectionsheet.emptyState" />
                      )
                    }
                    description={emptyState?.description}
                  />
                </div>
              ))}
            {isLoading && !data.length && <Loader />}
            {!skipNoData && noDataFound && (
              <div className="no-data-found-container">
                {noDataContent || (
                  <>
                    <div className="empty-state-msg">
                      <FormattedMessage id={'app.selectionsheet.emptyState'} />
                    </div>
                    <img src={envConfig.imageRoot + 'svg/not-found.svg'}></img>
                  </>
                )}
              </div>
            )}
          </TableBodyWrapper>
        </tbody>
      </table>
      {pagination &&
        (isClientPagination ? (
          <Pagination
            cardTable={cardTable}
            onPageChange={navigatePages}
            rowCount={rowCount}
            recordCount={recordCount}
            pages={pages}
            page={pageIndex + 1}
          />
        ) : (
          <Pagination
            cardTable={cardTable}
            onPageChange={navigatePages}
            setPageSize={setPageSize}
            rowCount={rowCount}
            recordCount={recordCount}
            pages={pages}
            page={activePage}
          />
        ))}
    </Styles>
  );
};

const FilterIcon = styled.div`
  visibility: ${(props) => (props.active ? 'visible' : 'hidden')} !important;
`;

const TableBodyWrapper = styled.div`
  padding: ${(props) => (props.cardTable ? '40px' : '')};
  max-height: ${(props) =>
    props.maxHeight
      ? `calc(100% - ${props.maxHeight - 50}px)`
      : 'calc(100% - 50px)'} !important;
`;
const Tr = styled.tr`
  opacity: ${(props) => (props.isLoading || props.isDisabled ? '0.4' : '1')};
  transition: opacity 200ms linear;
  cursor: ${(props) =>
    props.isLoading || props.isDisabled ? 'not-allowed' : 'default'};
  .td {
    background: ${(props) =>
      props.isSelected
        ? 'var(--sops-table-highlight-bg) !important'
        : 'var(--sops-white-transparent-bg)'};
    pointer-events: ${(props) =>
      props.isLoading || props.isDisabled ? 'none' : 'all'};
  }
`;

export default TableView;
